var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex flex-wrap", class: _vm.alignmentClass },
    [
      _vm.noContent
        ? _c("span", { class: _vm.noContentClasses }, [
            _vm._v(" " + _vm._s(_vm.noContentPlaceholder) + " "),
          ])
        : [
            _vm._t(
              "default",
              function () {
                return _vm._l(_vm.itemsToRender, function (item) {
                  return _c("ItemChip", {
                    key: item.id,
                    attrs: {
                      itemId: item.id,
                      itemName: item.name,
                      itemRole: item.role,
                      itemExtra: item.extra,
                      avatar: item.avatar,
                      routeName: _vm.routeName,
                      single: _vm.getSingle,
                      isPerson: _vm.isPerson,
                      routeParams: item.routeParams,
                      maxChipWidth: _vm.maxChipWidth,
                      textClasses: _vm.textClasses,
                      management: _vm.management,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ itemName }) {
                            return [
                              _vm._t("item", null, {
                                highlighted: item.highlighted,
                                itemName: itemName,
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  })
                })
              },
              { itemsToRender: _vm.itemsToRender }
            ),
            _vm.itemsMoreThanLimit
              ? _c(
                  "div",
                  { staticClass: "inline-block self-end pb-0.5" },
                  [
                    _vm.navigateTo
                      ? [
                          _c("RouterLink", { attrs: { to: _vm.navigateTo } }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "text-label text-primary-500 underline hover:no-underline",
                                class: _vm.textClasses,
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-xs font-semibold inline-block py-1 px-2 rounded-full last:mr-0 mr-1",
                                    class: _vm.allClasses,
                                  },
                                  [
                                    _vm._v(
                                      " + " + _vm._s(_vm.moreLinkNumber) + " "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ]
                      : [
                          _c(
                            "span",
                            {
                              staticClass:
                                "text-xs font-semibold inline-block py-1 px-2 rounded-full last:mr-0 mr-1",
                              class: _vm.allClasses,
                            },
                            [_vm._v(" + " + _vm._s(_vm.moreLinkNumber) + " ")]
                          ),
                        ],
                  ],
                  2
                )
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }